const MS_IN_SECOND = 1000;
const MS_IN_MINUTE = MS_IN_SECOND * 60;
const MS_IN_HOUR = MS_IN_MINUTE * 60;

const twoDigitString = source => String(source).padStart(2, '0');

function calculateTimeParts(ms) {
  const hours = Math.floor(ms / MS_IN_HOUR);
  ms %= MS_IN_HOUR;
  const minutes = Math.floor(ms / MS_IN_MINUTE);
  ms %= MS_IN_MINUTE;
  const seconds = Math.floor(ms / MS_IN_SECOND);
  const isInvalidParts = typeof hours === 'undefined' || typeof minutes === 'undefined' || typeof seconds === 'undefined' || Number.isNaN(hours) || Number.isNaN(minutes) || Number.isNaN(seconds);
  return isInvalidParts ? '' : {
    hours,
    minutes,
    seconds
  };
}

function checkAndCalculateTime(restrictions, currentTime) {
  if (!restrictions) {
    return {
      show: false,
      timeRemainingFormatted: '00:00:00'
    };
  }

  const {
    timer_start_date,
    timer_end_date
  } = restrictions || {};
  const currentDateTime = new Date(currentTime).getTime();
  const startDate = new Date(timer_start_date).getTime();
  const endDate = new Date(timer_end_date).getTime();
  const isOutOfRange = currentDateTime < startDate || endDate <= currentDateTime;
  const isInvalidDates = !startDate || !endDate;

  if (isInvalidDates || isOutOfRange) {
    return {
      show: false,
      timeRemainingFormatted: '00:00:00'
    };
  }

  const timeRemaining = endDate - currentDateTime;
  const {
    hours,
    minutes,
    seconds
  } = calculateTimeParts(timeRemaining);
  const timeRemainingFormatted = `${twoDigitString(hours)}:${twoDigitString(minutes)}:${twoDigitString(seconds)}`;
  return {
    show: true,
    timeRemainingFormatted
  };
}

function formatTimeRemainingToISO(timeString) {
  if (typeof timeString !== 'string' || !timeString.trim()) return '';
  const [hours, minutes] = timeString.split(':').map(Number);
  const invalidFormat = typeof hours === 'undefined' || typeof minutes === 'undefined' || Number.isNaN(hours) || Number.isNaN(minutes);
  return invalidFormat ? '' : `PT${hours}H${minutes}M`;
}

function fetchFormattedTime() {
  const now = new Date();
  const localTime = new Date(now.toLocaleString('en-US', {
    timeZone: 'America/Sao_Paulo'
  }));
  const year = localTime.getFullYear();
  const month = twoDigitString(localTime.getMonth() + 1);
  const day = twoDigitString(localTime.getDate());
  const hours = twoDigitString(localTime.getHours());
  const minutes = twoDigitString(localTime.getMinutes());
  const seconds = twoDigitString(localTime.getSeconds());
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

export { checkAndCalculateTime, fetchFormattedTime, formatTimeRemainingToISO };